import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { 
  Container, Paper, Typography, TextField, Button, Grid, Card, CardContent, 
  IconButton, MenuItem, Box, LinearProgress, Avatar, CardActionArea, InputAdornment 
} from '@mui/material';
import { Delete, FlightTakeoff, DirectionsCar, Home, Savings, MedicalServices, Star, AddCircle, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import FloatingCalculator from './FloatingCalculator';

function Investimentos({ user }) {
  const [investimentos, setInvestimentos] = useState([]);
  const [novoInv, setNovoInv] = useState({ 
    nome: '', 
    categoria: 'reserva', 
    metaFormatada: '', 
    frequencia: 'indefinido', 
    aporteFormatado: '' 
  });
  
  const navigate = useNavigate();

  const campoMetaSx = {
    '& .MuiOutlinedInput-root': {
      bgcolor: '#ffffff',
      borderRadius: 2.5,
      '& fieldset': { borderColor: '#c8d2ea' },
      '&:hover fieldset': { borderColor: '#8fa3d6' },
      '&.Mui-focused fieldset': { borderColor: '#1a237e' }
    },
    '& .MuiInputLabel-root': {
      color: '#44506b',
      fontWeight: 500
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#1a237e'
    }
  };

  // Busca os dados do Firebase
  const fetchInv = async () => {
    const snap = await getDocs(collection(db, `users/${user.uid}/investimentos`));
    setInvestimentos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => { fetchInv(); }, [user.uid]);

  // MÃ¡scara de Moeda (R$ 1.000,00)
  const handleMask = (v) => {
    const valorLimpo = v.replace(/\D/g, "");
    const res = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(parseFloat(valorLimpo || 0) / 100);
    return res === "NaN" ? "" : res;
  };

  // Salva no Banco de Dados (Com CorreÃ§Ã£o do HistÃ³rico)
  const salvar = async () => {
    const meta = parseFloat(novoInv.metaFormatada.replace(/\./g, '').replace(',', '.'));
    const aporte = parseFloat(novoInv.aporteFormatado.replace(/\./g, '').replace(',', '.'));
    
    // O valor do aporte inicial se torna o saldo atual
    const saldoInicial = aporte || 0;

    if (novoInv.nome) {
      // 1. Cria a Caixinha Principal
      const docRef = await addDoc(collection(db, `users/${user.uid}/investimentos`), {
        ...novoInv,
        meta: meta || 0,
        aportePrevisto: aporte || 0,
        saldoAtual: saldoInicial, 
        criadoEm: new Date().toISOString()
      });

      // 2. CORREÃ‡ÃƒO CRÃTICA: Se tiver saldo inicial, cria o histÃ³rico imediatamente
      if (saldoInicial > 0) {
        await addDoc(collection(db, `users/${user.uid}/investimentos/${docRef.id}/historico`), {
          tipo: 'deposito',
          valor: saldoInicial,
          descricao: 'Aporte Inicial',
          data: new Date().toISOString()
        });
      }

      // Limpa o formulÃ¡rio e recarrega
      setNovoInv({ nome: '', categoria: 'reserva', metaFormatada: '', frequencia: 'indefinido', aporteFormatado: '' }); 
      fetchInv();
    }
  };

  // Deleta a caixinha (Impede o clique de propagar para o card)
  const deletar = async (e, id) => {
    e.stopPropagation(); 
    if(window.confirm("Tem certeza? Isso apagarÃ¡ todo o histÃ³rico desta caixinha permanentemente.")) {
      await deleteDoc(doc(db, `users/${user.uid}/investimentos/${id}`)); 
      fetchInv();
    }
  };

  // Escolhe o Ã­cone certo
  const getIcon = (cat) => {
    const icons = { 
      viagem: <FlightTakeoff />, 
      carro: <DirectionsCar />, 
      casa: <Home />, 
      saude: <MedicalServices />, 
      sonho: <Star /> 
    };
    return icons[cat] || <Savings />;
  };

  return (
    <Container maxWidth="lg">
      <Button startIcon={<ArrowBack />} onClick={() => navigate('/')} sx={{ mb: 2, color: '#1a237e', fontWeight: 'bold' }}>
        Voltar
      </Button>
      
      <FloatingCalculator />
      
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold', color: '#1a237e', fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
        Minhas Caixinhas
      </Typography>
      
      {/* --- FORMULARIO DE CRIACAO (Estilo LNT Tech) --- */}
      <Paper elevation={0} sx={{ p: { xs: 1.5, sm: 2.5 }, mb: 2, borderRadius: 2, bgcolor: '#e8eaf6', border: '1px solid #c5cae9' }}>
        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 'bold', color: '#1a237e', display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '0.8rem', sm: '0.95rem' } }}>
          <AddCircle fontSize="small" /> NOVA META
        </Typography>
        
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4}>
            <TextField 
              fullWidth size="small" label="Nome da Meta" 
              placeholder="ex: Viagem 2026"
              value={novoInv.nome} 
              onChange={e => setNovoInv({...novoInv, nome: e.target.value})} 
              InputLabelProps={{ shrink: true }}
              sx={campoMetaSx}
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <TextField select fullWidth size="small" label="Ãcone" value={novoInv.categoria} onChange={e => setNovoInv({...novoInv, categoria: e.target.value})} InputLabelProps={{ shrink: true }} sx={campoMetaSx}>
              <MenuItem value="reserva">Reserva</MenuItem>
              <MenuItem value="viagem">Viagem</MenuItem>
              <MenuItem value="carro">Carro</MenuItem>
              <MenuItem value="casa">Casa</MenuItem>
              <MenuItem value="saude">SaÃºde</MenuItem>
              <MenuItem value="sonho">Sonho</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6} sm={2}>
            <TextField 
              fullWidth size="small" label="Meta Final" 
              value={novoInv.metaFormatada} 
              onChange={e => setNovoInv({...novoInv, metaFormatada: handleMask(e.target.value)})} 
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
              InputLabelProps={{ shrink: true }} sx={campoMetaSx} 
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <TextField select fullWidth size="small" label="Aporte" value={novoInv.frequencia} onChange={e => setNovoInv({...novoInv, frequencia: e.target.value})} InputLabelProps={{ shrink: true }} sx={campoMetaSx}>
              <MenuItem value="indefinido">Sem prazo</MenuItem>
              <MenuItem value="mensal">Mensal</MenuItem>
              <MenuItem value="diario">DiÃ¡rio</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6} sm={2}>
             <TextField 
               disabled={novoInv.frequencia === 'indefinido'} 
               fullWidth size="small" label="Valor Inicial" 
               value={novoInv.aporteFormatado} 
               onChange={e => setNovoInv({...novoInv, aporteFormatado: handleMask(e.target.value)})} 
               InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
               InputLabelProps={{ shrink: true }} sx={campoMetaSx} 
             />
          </Grid>
          <Grid item xs={12}>
            <Button 
              fullWidth size="small" variant="contained" 
              sx={{ bgcolor: '#1a237e', fontWeight: 'bold', height: 40, '&:hover': { bgcolor: '#0d1440' }, fontSize: { xs: '0.8rem', sm: '0.95rem' } }} 
              onClick={salvar}
            >
              CRIAR CAIXINHA
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* --- LISTA DE COFRES --- */}
      <Box sx={{ 
        display: 'flex', 
        overflowX: 'auto', 
        gap: 1.5, 
        pb: 2, 
        scrollSnapType: 'x mandatory', 
        '&::-webkit-scrollbar': { display: 'none' },
        px: 0.5
      }}>
        {investimentos.map(inv => {
          // Calcula progresso seguro (0 a 100%)
          const progresso = inv.meta > 0 ? Math.min((inv.saldoAtual / inv.meta) * 100, 100) : 0;

          return (
            <Box key={inv.id} sx={{ minWidth: { xs: 180, sm: 220 }, maxWidth: 220, scrollSnapAlign: 'center' }}>
              <Card 
                sx={{ 
                  borderRadius: 3, 
                  position: 'relative', 
                  transition: '0.3s', 
                  '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 },
                  height: '100%'
                }}
              >
                
                {/* BotÃ£o de Deletar (Fica por cima de tudo) */}
                <Box sx={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}>
                  <IconButton size="small" onClick={(e) => deletar(e, inv.id)}>
                     <Delete fontSize="small" sx={{ color: '#e0e0e0', '&:hover': { color: '#ef5350' } }} />
                  </IconButton>
                </Box>

                {/* Ãrea ClicÃ¡vel que leva aos Detalhes */}
                <CardActionArea 
                  onClick={() => navigate(`/investimentos/${inv.id}`)} 
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}
                >
                  <CardContent sx={{ pt: 2, pb: '12px !important', px: { xs: 1.5, sm: 2 }, width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                      <Avatar sx={{ bgcolor: '#e3f2fd', color: '#1565c0', width: 40, height: 40, mr: 1, flexShrink: 0 }}>
                        {getIcon(inv.categoria)}
                      </Avatar>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#0a1929', lineHeight: 1.1, fontSize: { xs: '0.9rem', sm: '1rem' }, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {inv.nome}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
                          {inv.categoria.toUpperCase()}
                        </Typography>
                      </Box>
                    </Box>

                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2e7d32', mb: 1, fontSize: { xs: '1.1rem', sm: '1.3rem' } }}>
                      R$ {inv.saldoAtual?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </Typography>
                    
                    {inv.meta > 0 && (
                      <>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography variant="caption" color="textSecondary">Progresso</Typography>
                          <Typography variant="caption" fontWeight="bold" color="#1a237e">{progresso.toFixed(0)}%</Typography>
                        </Box>
                        <LinearProgress 
                          variant="determinate" 
                          value={progresso} 
                          sx={{ 
                            height: 8, 
                            borderRadius: 5, 
                            bgcolor: '#f0f0f0', 
                            '& .MuiLinearProgress-bar': { bgcolor: progresso >= 100 ? '#2e7d32' : '#1a237e' } 
                          }} 
                        />
                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5, textAlign: 'right' }}>
                          Meta: R$ {inv.meta?.toLocaleString('pt-BR')}
                        </Typography>
                      </>
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            </Box>
          );
        })}
      </Box>
    </Container>
  );
}

export default Investimentos;

